// extracted by mini-css-extract-plugin
export default {"markdownCopilotReport":"styles_markdownCopilotReport__6Ec0X"};